import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import {
  fetchAllLeaveReport,
  fetchAllLeaveReportDetails,
} from "../../../core/data/redux/reports/leave_reports/leavereports.Action";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { fetchAllLeaveRequestsWithCancelation } from "../../../core/data/redux/attendance/leave/leaveAction";
import { formatDate } from "../../../core/utils/FormatData";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { exportToCSV, exportToExcel } from "../../../core/common/GlobalFunctions/exportTableData";

interface LeaveReportProps {
  statusFilter?: string | null;
  year?: string;
  showOnlyTable?: boolean;
}

const LeaveReport: React.FC<LeaveReportProps> = ({ statusFilter: propStatus, year: propYear ,showOnlyTable}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string | null>(propStatus || null);
  const [leaveConfig, setleaveConfig] = useState<any>(null);
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const { leaveRequests } = useSelector(
    (state: any) => state.attendance.leaveRequests
  );
  const [leavecountDetails, setleavecountDetails] = useState<any>(null);
  const [selectedYear, setSelectedYear] = useState(propYear || "2025");
  const [tableKey, setTableKey] = useState(0);
  const [alldata, setalldata] = useState<any>("")
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = alldata ? alldata : [];


  useEffect(() => {
    if (propStatus) setStatusFilter(propStatus);
    if (propYear) setSelectedYear(propYear);
  }, [propStatus, propYear]);


  function filterLeaveData(data: any[]) {
    return data.map(leave => ({
      LeaveType: leave.LeaveType || "N/A",
      Description: leave.Description || "N/A",
      FromDate: leave.FromDate || "N/A",
      ToDate: leave.ToDate || "N/A",
      Duration: leave.Duration || 0,
      LeaveRequestStatus: leave.LeaveRequestStatus || "N/A",
      LeaveMode: leave.LeaveMode || "N/A",
      EmployeeName: leave.employeeName || "N/A",
      EmployeeNumber: leave.EmployeeNumber || "N/A",
    }));
  }

  const data2 = filterLeaveData(data);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, leaveRequests]);

  useEffect(() => {
    // dispatch(fetchAllLeaveRequests());
    dispatch(fetchAllLeaveReport(selectedYear)).then((res) => {
      setleavecountDetails(res.payload.data);
    });
    dispatch(fetchAllLeaveReportDetails(selectedYear)).then((res) => {
      setleaveConfig(res.payload.data);
    });
    dispatch(fetchAllLeaveRequestsWithCancelation())
      .then((res) => {
        setalldata(res.payload.data)
      })
  }, []);

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllLeaveReportDetails(selectedYear))
        .then((res) => {
          setleaveConfig(res.payload.data);
        })
        .catch((err: any) => {
          console.error("Failed to fetch Leave data:", err);
        });
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  const filteredData = useMemo(() => {
    return filterData(
      data || [],
      statusFilter ? { LeaveRequestStatus: statusFilter } : {},
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [dispatch, data, leaveRequests, selectedSort, statusFilter]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, data, leaveRequests, selectedSort, statusFilter]);

  const columns = [
  {
    title: "Employee Name",
    dataIndex: "employeeName",
    render: (text: String, record: any) => (
      <div className="d-flex align-items-center">
        <Link
          to="#"
          className="avatar avatar-md"
          data-bs-toggle="modal"
          data-inert={true}
          data-bs-target="#view_details"
        >
          <img
            src={record.PictureURL || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
            alt="profile"
            className="img-fluid rounded-circle"
          />
        </Link>

        <div className="ms-2">
          <Link to={all_routes.invoiceDetails} className="link-default">
            {record?.employeeName}
          </Link>
        </div>
      </div>
    ),
    sorter: (a: any, b: any) => a.employeeName.length - b.employeeName.length,
  },

  {
    title: "Leave Type",
    dataIndex: "LeaveType",
    render: (text: String, record: any) => (
      <span className="text-dark">{record.LeaveType}</span>
    ),
    sorter: (a: any, b: any) => a.LeaveType.length - b.LeaveType.length,
  },

  {
    title: "From",
    dataIndex: "FromDate",
    render: (text: string) => formatDate(text),
    sorter: (a: any, b: any) => a.FromDate.length - b.FromDate.length,
  },
  {
    title: "To Date",
    dataIndex: "ToDate",
    render: (text: string) => formatDate(text),
    sorter: (a: any, b: any) => a.ToDate.length - b.ToDate.length,
  },
  {
    title: "Duration",
    dataIndex: "Duration",
    sorter: (a: any, b: any) => a.Duration.length - b.Duration.length,
  },
  {
    title: "Status",
    dataIndex: "LeaveRequestStatus",
    render: (text: String, record: any) => (
      <span
        className={`badge d-inline-flex align-items-center badge-xs ${
          record.LeaveRequestStatus === "Approved"
            ? "badge-soft-success"
            : record.LeaveRequestStatus === "Pending"
            ? "badge-soft-purple"
            : "badge-soft-warning"
        }`}
      >
        {record.LeaveRequestStatus}
      </span>
    ),
    sorter: (a: any, b: any) => a.Status.length - b.Status.length,
  },
  {
    title: "Cancellation_status",
    dataIndex: "Cancellation_status",
    sorter: (a: any, b: any) =>
      a.Cancellation_status.length - b.Cancellation_status.length,
  },
];


  useEffect(() => {
    const approvedPerMonth = new Array(12).fill(0);
    const pendingPerMonth = new Array(12).fill(0);
    const rejectedPerMonth = new Array(12).fill(0);

    if (leaveConfig && leaveConfig.length > 0) {
      leaveConfig.forEach(({ month, approved, pending, rejected }: any) => {
        const index = month - 1; // month is 1-based
        approvedPerMonth[index] = parseInt(approved);
        pendingPerMonth[index] = parseInt(pending);
        rejectedPerMonth[index] = parseInt(rejected);
      });
    }

    setLeavechart((prev: any) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          data: approvedPerMonth,
        },
        {
          ...prev.series[1],
          data: pendingPerMonth,
        },
        {
          ...prev.series[2],
          data: rejectedPerMonth,
        },
      ],
    }));
  }, [leaveConfig, dispatch, leaveRequests]);

  //New Chart
  const [leavechart, setLeavechart] = useState<any>({
    series: [
      {
        name: "Approved",
        data: new Array(12).fill(0),
      },
      {
        name: "Pending",
        data: new Array(12).fill(0),
      },
      {
        name: "Rejected",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      type: "bar",
      height: 210, // Change this value to your desired height
      stacked: true,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ], // Update to match your time frame
    },
    yaxis: {
      labels: {
        offsetX: -15,
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      show: false,
    },
    colors: ["#03C95A", "#FFC107", "#0C4B5E", "#F26522"],
    dataLabels: {
      enabled: false,
    },
  });
if (showOnlyTable) {
  return (
   <Table
        key={tableKey}
        dataSource={filteredData}
        columns={columns}
        Selection={false}
      />
  );
}
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Leave Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leave Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "Leave_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "Leave_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                {/* Total Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2 overflow-hidden">
                        <div>
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Total Leaves
                          </p>
                          <h4>{leavecountDetails?.[0].TotalLeaves}</h4>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-primary bg-transparent-primary rounded-circle d-flex align-items-center justify-content-center">
                              <i className="ti ti-calendar-x text-primary" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Total Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2 overflow-hidden">
                        <div>
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Approved Leaves
                          </p>
                          <h4>{leavecountDetails?.[0].ApprovedLeaves || 0}</h4>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-success bg-transparent-success rounded-circle d-flex align-items-center justify-content-center">
                              <i className="ti ti-calendar-x text-success" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Inactive Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2 overflow-hidden">
                        <div>
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Pending Requests
                          </p>
                          <h4>{leavecountDetails?.[0].PendingLeaves || 0}</h4>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-skyblue bg-transparent-skyblue rounded-circle d-flex align-items-center justify-content-center">
                              <i className="ti ti-calendar-x text-skyblue" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Inactive Companies */}
                {/* Company Location */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2 overflow-hidden">
                        <div>
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Rejected Leaves
                          </p>
                          <h4>{leavecountDetails?.[0].RejectedLeaves || 0}</h4>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-danger bg-transparent-danger rounded-circle d-flex align-items-center justify-content-center">
                              <i className="ti ti-calendar-x text-danger" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Company Location */}
              </div>
            </div>
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center row-gap-2">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-bar text-danger" />
                      </span>
                      <h5>Leaves </h5>
                    </div>
                    <div className="d-flex align-items-center">
                      <p className="d-inline-flex align-items-center me-2 mb-0">
                        <i className="ti ti-square-filled fs-12 text-success me-2" />
                        Approved
                      </p>
                      <p className="d-inline-flex align-items-center mb-0 me-2">
                        <i className="ti ti-square-filled fs-12 text-warning me-2" />
                        Pending
                      </p>
                      <p className="d-inline-flex align-items-center mb-0 me-2">
                        <i
                          className="ti ti-square-filled fs-12 me-2"
                          style={{ color: "#0C4B5E" }}
                        />
                        Rejected
                      </p>
                    </div>

                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0">
                  <ReactApexChart
                    id="payslip-chart"
                    options={leavechart}
                    series={leavechart.series}
                    type="bar"
                    height={210}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Leave list</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {statusFilter || "Select Status"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Approved")}
                      >
                        Approved
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Pending")}
                      >
                        Pending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Rejected")}
                      >
                        Rejected
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter(null)} // Clear filter
                      >
                        Clear Filter
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default LeaveReport;
